export default function Navlink({
  label,
  href,
  isButton = false,
  child = null,
  isOpen = false,
  onParentClick,
  isActive = false,
}) {
  return (
    <div className="font-ttFirsNeue relative group">
      {isButton ? (
        <a
          href={href}
          className="px-6 py-3 border border-neutral-600 backdrop-blur-xl bg-white/10 rounded-md"
          onClick={(e) => {
            if (href === "#") {
              e.preventDefault();
              onParentClick();
            }
          }}
        >
          {label}
        </a>
      ) : (
        <a
          href={href}
          onClick={(e) => {
            if (href === "#") {
              e.preventDefault();
              onParentClick();
            }
          }}
          className={`${isActive ? "text-[#ffaf00]" : "text-white"}`}
        >
          {label}
        </a>
      )}

      {child ? (
        <div
          className={`lg:absolute mt-2 lg:mt-4 lg:min-w-40 lg:w-full bg-black/30 backdrop-blur-lg p-4 text-left text-sm rounded-lg ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <ul className="space-y-3">
            {child
              .filter((value) => value.isHide === false)
              .map((value, index) => (
                <li key={index + 2}>
                  <a
                    href={value.href}
                    className={`${
                      value.active ? "text-[#ffaf00]" : "text-white"
                    }`}
                    onClick={(e) => {
                      if (value.href === "#") {
                        e.preventDefault();
                      }
                    }}
                  >
                    {value.label}
                  </a>
                </li>
              ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
